import PoolQueueSummary from './PoolQueueSummary';

export default PoolQueueSummary;
